// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"2219359c","258":"d89d6f12","377":"85f6b97f","417":"4b3b6bfc","467":"53970fe9","626":"e5e40771","870":"3bda2713"}[chunkId] + ".js";
};